<template>
  <div>
    <b-table striped :items="users" small :fields="addedFields" :busy="inventoryLoading">
        <template #thead-top="">
        <b-tr>
            <b-th colspan="5"><h5>Inventory - ${{ inventoryTotal }}</h5></b-th>
        </b-tr>
        </template>

        <template #table-busy>
        <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="mx-3">Loading...</strong>
        </div>
        </template>

        <template #cell(amount)="data">
        <span class="text-success">${{ formatPrice(data.value) }}</span>
        </template>

        <template #cell(name)="data">
          <b-link @click="userLink(data.value)">{{ data.value }}</b-link>
        </template>

        <template #cell(inactiveCount)="data">
          <b-link @click="inactiveLink(data.item.name)">{{ data.value }}</b-link>
        </template>

        <template #cell(discogsIntegrations)="data">
          <b-link @click="discogsLink(data.item.name)">{{ data.value }}</b-link>
        </template>
    </b-table>

    <b-table class="mt-5" striped :items="sources" small :fields="sourceFields" :busy="inventoryLoading">
        <template #thead-top="">
        <b-tr>
            <b-th colspan="2"><h5>Sources</h5></b-th>
        </b-tr>
        </template>

        <template #table-busy>
        <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="mx-3">Loading...</strong>
        </div>
        </template>

        <template #cell(amount)="data">
        <span class="text-success">${{ formatPrice(data.value) }}</span>
        </template>

        <template #cell(name)="data">
        <span v-if="!data.value">(none)</span>
        <b-link @click="sourceLink(data.value)">{{ data.value }}</b-link>
        </template>
    </b-table>
  </div>
</template>

<script>
  import statsApi from "@/api/stats";  
  import utils from "@/mixins/utils";

  export default {
    name: 'InventoryStats',
    mixins: [ statsApi, utils ],
    props: [ 'from', 'to', 'refresh' ],
    data() {
      return {
        users: [],
        sources: [],
        addedFields: [
          { key: 'name', label: 'User'  },
          { key: 'activeCount', label: 'Count'  },
          { key: 'amount', label: 'Amount'  },
          { key: 'inactiveCount', label: 'Backups'},
          { key: 'discogsIntegrations', label: 'Discogs'}
        ],
        sourceFields: [
          { key: 'name', label: 'Source'  },
          { key: 'count', label: 'Count'  },
          { key: 'amount', label: 'Amount'  },
        ],
        inventoryLoading: false,
      }
    },
    methods: {
      userLink(user) {
        let query = { added: this.from, addedBy: user };

        if (this.to) {
          query['addedTo'] = this.to;
        }

        this.$router.push({ name: 'inventory', params: { outsideQuery: { filters: query } } })
      },
      inactiveLink(name) {
        let query = { inactiveUpdated: this.from, inactiveUpdatedBy: name };

        if (this.to) {
          query['inactiveUpdatedTo'] = this.to;
        }

        this.$router.push({ name: 'inventory', params: { outsideQuery: { filters: query } } })

      },
      discogsLink(name) {
        let query = { integrationAdded: this.from, integrationAddedBy: name, integrationPlatform: 'discogs'};

        if (this.to) {
          query['integrationAddedTo'] = this.to;
        }

        this.$router.push({ name: 'inventory', params: { outsideQuery: { filters: query } } })
      },
      sourceLink(source) {
        let query = { added: this.from };
        if (source !== "(none)") {
          query['source'] = source
        } else {
          query['noSource'] = true;
        }
        if (this.to) {
          query['addedTo'] = this.to;
        }

        this.$router.push({ name: 'inventory', params: { outsideQuery: { filters: query } } })
      },
      async getStats() {
        this.inventoryLoading = true;

        try {
            const inventoryStats = await this.fetchInventoryStats(this.from, this.to);
    
            this.users = inventoryStats.users;
            this.sources = inventoryStats.sources;
        } catch (err) {
            this.showError(err, 'Inventory Stats');
        } finally {
            this.inventoryLoading = false;
        }
      },
    },
    computed: {
      inventoryTotal() {
        let price = 0;

        this.users.forEach(p => {
          if (!isNaN(p.amount)) {
            price += p.amount;
          }
        });

        return price.toLocaleString();
      }
    },
    watch: {
      from() {
        this.getStats();
      },
      to() {
        this.getStats();
      },
      refresh() {
        this.getStats();
      }
    }
  }
</script>

<style scoped>
  .table thead tr:first-child th {
    border-top: 0;
  }
</style>